import { ActionTypes as action } from "./action-types";
import timerService from "../../../api/TimerService";

const actions = {

    async startTimer({ commit }, data) {
        const response = await timerService.startTimer(data);
        return response
    },
    async updateTimer({ commit }, data) {
        const response = await timerService.updateTimer(data);
        return response
    },
    async timerActions({ commit }, data) {
        const response = await timerService.timerActions(data);
        return response
    },
    async saveTimer({ commit }, data) {
        const response = await timerService.saveTimer(data);
        return response
    },
    resetState({ commit }) {
        commit(action.RESET_STATE);
    },
};

export default actions;
